export { ZoomIn as default } from './ZoomIn';
